import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import { EmailBaseCampaign } from './email_base';
import type { ILegacyEmailBaseCampaign } from './types';

export abstract class LegacyEmailBaseCampaign<
  T extends ILegacyEmailBaseCampaign = ILegacyEmailBaseCampaign,
> extends EmailBaseCampaign<T> {
  public override get constraints(): TConstraints<T> {
    return super.constraints;
  }

  constructor(attributes: Partial<T>) {
    super(attributes);

    makeObservable(this);
  }
}
